// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"7e983ebe","453":"406c13f6"}[chunkId] + ".chunk.js";
};